import { storage } from './storage';
import { getCurrentUrl } from './urls';
const extractCodeInfoAndCleanUrl = () => {
    const hashValue = window.location.hash.replace('#', '');
    if (!hashValue) {
        return undefined;
    }
    const currentUrlQueryParams = new URLSearchParams(hashValue);
    const error = currentUrlQueryParams.get('error');
    if (error) {
        return undefined;
    }
    const code = currentUrlQueryParams.get('code');
    const state = currentUrlQueryParams.get('state');
    currentUrlQueryParams.delete('code');
    currentUrlQueryParams.delete('state');
    currentUrlQueryParams.delete('access_token');
    currentUrlQueryParams.delete('token_type');
    const newFragment = currentUrlQueryParams.toString();
    history.pushState(null, document.title, window.location.href.split('#')[0] + newFragment ? `#${newFragment}` : '');
    if (!code || !state) {
        return undefined;
    }
    const storageItem = storage.readAndClear();
    if (!storageItem || state !== storageItem.state) {
        return undefined;
    }
    return {
        code: code,
        codeVerifier: storageItem.codeVerifier,
        redirectUri: getCurrentUrl(),
    };
};
export default extractCodeInfoAndCleanUrl;
//# sourceMappingURL=extractCodeInfoAndCleanUrl.js.map